import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';

import { CompositionId } from '@/lib/enum';
import { SdsProduct, SdsSection3 } from '@/interfaces/model/general/sds';
import SdsSection3MultiInputForm from '@/views/dashboard/sdsDrawer/forms/SdsSection3MultiInputForm.vue';
import CompositionForm from '@/views/dashboard/sdsDrawer/forms/SdsSection3CompositionForm.vue';
import { VForm } from 'vuetify/lib/components';
import { readUserLocale } from '@/store/main/getters';
import { store } from '@/store/index';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';
import { defineMessages } from '@/lib/i18n';

type Props = {
  isEditing?: boolean;
  section3: SdsSection3;
  productIndex?: number;
  products?: SdsProduct[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection3',
  props: {
    isEditing: { type: Boolean, default: false },
    section3: null,
    productIndex: { default: 0 },
    products: { default: () => [] }
  },
  emits: ["update:section3", "update:products"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:section3', data: SdsSection3): void;
  (e: 'update:products', data: Array<SdsProduct>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isEditing: boolean, section3: SdsSection3, productIndex: number, products: SdsProduct[] };

const $t = i18n.t.bind(i18n);
const locale = computed(() => readUserLocale(store));
const textProperty = locale.value === 'ja-JP' ? 'text' : 'textEn';

const m = defineMessages({
  composition: '構成',
});



const compositionHeader = [
  {
    text: $t(m.composition),
    value: 'composition',
    sortable: false,
  },
  { text: '', value: 'action', sortable: false, align: 'end' },
];
const headerSection3Synonyms = [
  { text: $t(sharedMessages.synonyms), value: 'synonyms', sortable: false },
  { text: '', value: 'action', sortable: false, align: 'end' },
];
const headerSection3Aliases = [
  { text: $t(sharedMessages.aliases), value: 'aliases', sortable: false },
  { text: '', value: 'action', sortable: false, align: 'end' },
];
const headerSection3ChemicalProperties = [
  {
    text: $t(sharedMessages.chemicalProperties),
    value: 'chemical_properties',
    sortable: false,
  },
  { text: '', value: 'action', sortable: false, align: 'end' },
];

const isValidSection3EditForm = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>(null);

const showEditCompositionModal = ref(false);
const showEditSynonymsModal = ref(false);
const showEditAliasesModal = ref(false);
const showEditChemicalPropertiesModal = ref(false);

const updatedCompositionId = ref<number>(0);
const updatedSynonyms = ref<string[]>([]);
const updatedAliases = ref<string[]>([]);
const updatedChemicalProperties = ref<string[]>([]);

const closeEditCompositionModal = (): void => {
  showEditCompositionModal.value = false;
};
const closeEditSynonymsModal = () => {
  showEditSynonymsModal.value = false;
};
const closeEditAliasesModal = () => {
  showEditAliasesModal.value = false;
};
const closeEditChemicalPropertiesModal = () => {
  showEditChemicalPropertiesModal.value = false;
};



const handleEditCompositionButtonClick = (): void => {
  showEditCompositionModal.value = true;
  updatedCompositionId.value = props.section3.composition_id;
};

const handleUpdateCompositionButtonClick = () => {
  const section3 = { ...props.section3 };
  section3.composition_id = updatedCompositionId.value;
  emits('update:section3', section3);
  closeEditCompositionModal();
};

const handleEditSynonymsButtonClick = () => {
  showEditSynonymsModal.value = true;
  updatedSynonyms.value =
    props.section3.synonyms.length > 0 ? [...props.section3.synonyms] : [''];
};
const handleUpdateSynonymsButtonClick = () => {
  const section3 = { ...props.section3 };
  section3.synonyms = updatedSynonyms.value.filter((v) => v !== '');
  emits('update:section3', section3);
  closeEditSynonymsModal();
};

const handleEditAliasesButtonClick = () => {
  showEditAliasesModal.value = true;
  updatedAliases.value =
    props.section3.aliases.length > 0 ? [...props.section3.aliases] : [''];
};
const handleUpdateAliasesButtonClick = () => {
  const section3 = { ...props.section3 };
  section3.aliases = updatedAliases.value.filter((v) => v !== '');
  emits('update:section3', section3);
  closeEditAliasesModal();
};

const handleEditChemicalPropertiesButtonClick = () => {
  showEditChemicalPropertiesModal.value = true;
  updatedChemicalProperties.value =
    props.section3.chemical_properties.length > 0
      ? [...props.section3.chemical_properties]
      : [''];
};
const handleUpdateChemicalPropertiesButtonClick = () => {
  const section3 = { ...props.section3 };
  section3.chemical_properties = updatedChemicalProperties.value.filter(
    (v) => v !== ''
  );
  emits('update:section3', section3);
  closeEditChemicalPropertiesModal();
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,$t, locale, textProperty, m, props, compositionHeader, headerSection3Synonyms, headerSection3Aliases, headerSection3ChemicalProperties, isValidSection3EditForm, form, showEditCompositionModal, showEditSynonymsModal, showEditAliasesModal, showEditChemicalPropertiesModal, updatedCompositionId, updatedSynonyms, updatedAliases, updatedChemicalProperties, closeEditCompositionModal, closeEditSynonymsModal, closeEditAliasesModal, closeEditChemicalPropertiesModal, emits, handleEditCompositionButtonClick, handleUpdateCompositionButtonClick, handleEditSynonymsButtonClick, handleUpdateSynonymsButtonClick, handleEditAliasesButtonClick, handleUpdateAliasesButtonClick, handleEditChemicalPropertiesButtonClick, handleUpdateChemicalPropertiesButtonClick, CompositionId, SdsSection3MultiInputForm, CompositionForm, sharedMessages }
}

})